import { CalciteTooltip } from "@esri/calcite-components-react";
import React from "react";
import { Criteria } from "services/APIBase.d";
import tw from "twin.macro";

interface FiltersDisplayProps {
  // Add your props here
  criterias: Criteria[];
  cols: Array<{ field: string; title: string }>;
}

const FiltersDisplay: React.FC<FiltersDisplayProps> = ({ criterias, cols }) => {
  if (criterias.length === 0) {
    return null;
  }

  return (
    <>
      <div
        css={[tw`flex items-center`]}
        style={{
          cursor: "pointer",
        }}
        id="filter-info"
      >
        <span css={[tw`text-sm text-gray-600 `]}>
          {criterias.length} filter
          {criterias.length !== 1 ? "s" : ""} applied
        </span>
      </div>
      <CalciteTooltip referenceElement={"filter-info"} placement="right">
        <span css={[tw`text-sm text-gray-600`]}>
          {criterias.map((c, index) => {
            const column = cols.find((col) => col.field === c.field);
            const displayValue =
              c.type === "BETWEEN" && typeof c.value === "string"
                ? (() => {
                    const [start, end] = c.value.split(",");
                    const formatValue = (value: string) => {
                      if (c.field === "CPN") {
                        const digits = value.replace(/\D/g, "");
                        if (digits.length === 10) {
                          return `(${digits.slice(0, 3)}) ${digits.slice(
                            3,
                            6
                          )}-${digits.slice(6)}`;
                        }
                      }
                      return value;
                    };
                    return `${formatValue(start)} - ${formatValue(end)}`;
                  })()
                : c.value;

            return (
              <div key={index}>
                <strong>
                  {column?.title ||
                    (c.field === "CPN" ? "Telephone Number" : c.field)}
                  :
                </strong>{" "}
                {displayValue}
              </div>
            );
          })}
        </span>
      </CalciteTooltip>
    </>
  );
};

export default FiltersDisplay;
